module.exports = __webpack_public_path__ + "static/media/image-user.e8584fc7.svg";